import { render, staticRenderFns } from "./CamionGrid.vue?vue&type=template&id=71b7c726&scoped=true&"
import script from "./CamionGrid.vue?vue&type=script&lang=js&"
export * from "./CamionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7c726",
  null
  
)

export default component.exports